<section aria-label="Filters" class="pb-4">
  <h2 class="text-dark-purple text-3xl font-bold pt-5 pb-2">Filters</h2>

  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
    <div class="w-full mt-6">
      <prism-input
        inputType="text"
        [control]="searchControl"
        label="Search"
        labelColor="sr-only"
        [required]="false"
        placeHolder="Search for name, course, etc..."
        autocomplete="off"
        [hasSearch]="true"
        (search)="search.emit()">
      </prism-input>
    </div>

    <div class="w-full">
      <prism-select-school-year
        [required]="false"
        [readOnly]="false"
        label="Academic Year"
        placeholder="All academic years"
        [control]="schoolYearControl">
      </prism-select-school-year>
    </div>

    <div class="w-full">
      <prism-select-organization
        [control]="organizationControl"
        [label]="'District'"
        [required]="false"
        [readOnly]="false">
      </prism-select-organization>
    </div>

    <div class="w-full">
      <prism-select
        [selectOptions]="completionStatusOptions"
        label="Completion Status"
        placeHolder="All completion statuses"
        [control]="completionStatusControl"
        [required]="false"
        [readOnly]="false"
        [allowDeselect]="true"
        labelClass="">
      </prism-select>
    </div>
  </div>
</section>
